import { CustomFontState } from 'types/customFont.types';

const S3_FONT_BUCKET_LINK = import.meta.env.VITE_S3_FONT_BUCKET_LINK;

/**
 * Test if a font is a custom uploaded font by family name.
 *
 * @param family
 * @returns True if it is a custom uploaded font, otherwise false.
 */
const isCustomFont = (family: string) => /^cus_/.test(family);

const loadCustomFonts = async (families: string[], fontMap: Map<string, CustomFontState>): Promise<string[]> => {
  const fontFaces: FontFace[] = [];

  // Create the FontFace objects to all custom font famulies
  families.forEach((family) => {
    const font = fontMap.get(family);
    if (font && font.hash) {
      const url = new URL(`${S3_FONT_BUCKET_LINK}/${font.hash}`).toString();

      fontFaces.push(new FontFace(font.font_name, `url(${url})`));
    }
  });

  const result = await Promise.allSettled(fontFaces.map((fontFace) => fontFace.load()));
  const loadedFonts = new Set<string>();

  result.forEach((fontFace) => {
    if (fontFace.status === 'fulfilled') {
      document.fonts.add(fontFace.value);
      loadedFonts.add(fontFace.value.family);
    } else {
      console.error(fontFace.reason);
    }
  });

  return [...loadedFonts];
};

export { isCustomFont, loadCustomFonts };
